import { CUSTOMERS_ACTION_TYPES } from '../../actions/customer/customer_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const customers = (state = initialState, action) => {
    switch (action.type) {
        case CUSTOMERS_ACTION_TYPES.GET_CUSTOMERS_SUCCESS:
            return { ...state, collection: action.payload };
        case CUSTOMERS_ACTION_TYPES.POST_CUSTOMER_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case CUSTOMERS_ACTION_TYPES.PUT_CUSTOMER_SUCCESS:
            const updatedCustomer = action.payload;
            return { ...state, collection: state.collection.map((customer) => customer.uuid !== updatedCustomer.uuid ? customer : { ...customer, ...updatedCustomer }) };
        // TODO check if needed since it causes issues with pagination
        // case CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS:
        //     const deletedCustomer = action.payload;
        //     return { ...state, collection: state.collection.filter(customer => customer.uuid !== deletedCustomer), totalCount: state.totalCount - 1 };
        case CUSTOMERS_ACTION_TYPES.UPDATE_CUSTOMERS_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
